import Experience from "./components/Experience";
import Home from "./components/Home";
import SideBar from "./components/SideBar"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import Technology from "./components/Technology";
import Volunteering from "./components/Volunteering";
import Certification from "./components/Certification";
import Articles from "./components/Articles";
import Contact from "./components/Contact";
import Projects from "./components/Projects";
import Publications from "./components/Publications";
import { useEffect } from "react";

function App() {

  useEffect(() => {
    // window.location.replace('https://hemaprakashraghu.me')
  }, [])

  return (
    <div className="w-full min-h-screen bg-[#18181b]">
      <BrowserRouter>
        <div className="w-full h-full">
            <Routes>
              <Route path="/" exact Component={Home} />
              <Route path="/experience" Component={Experience} />
              <Route path="/technology" Component={Technology} />
              <Route path="/volunteering" Component={Volunteering} />
              <Route path="/certification" Component={Certification} />
              <Route path="/articles" Component={Articles} />
              <Route path="/contact" Component={Contact} />
              <Route path="/projects" Component={Projects} />
              <Route path="/publications" Component={Publications} />
            </Routes>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
